var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhitePlayer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5873 16.6727C30.4955 17.9524 31.4495 18.5922 31.782 19.3987C32.0727 20.1038 32.0727 20.8962 31.782 21.6013C31.4495 22.4078 30.4955 23.0476 28.5873 24.3273L7.10896 38.7315C4.79966 40.2802 3.645 41.0545 2.68751 40.997C1.85338 40.9469 1.08282 40.5321 0.578682 39.8617C-4.3072e-06 39.0921 0 37.6962 0 34.9042V6.0958C0 3.30382 -4.3072e-06 1.90784 0.578682 1.13832C1.08282 0.467929 1.85338 0.0530857 2.68751 0.00298433C3.645 -0.0545258 4.79966 0.719822 7.10896 2.26853L28.5873 16.6727Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhitePlayer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/whitePlayer.7144042187d6414e36fe62781cddb610.svg";